"use client";

import { createContext, type PropsWithChildren, useContext } from "react";
import type { GlobalStoryblok } from "~/generated/sb/blok-types";

interface GlobalContext {
	data: GlobalStoryblok | null;
	preview: boolean;
}

const GlobalContext = createContext<GlobalContext>(null!);

export interface GlobalProviderProps extends Pick<GlobalContext, "data" | "preview"> {}

export const GlobalProvider = ({
	children,
	data,
	preview,
}: PropsWithChildren<GlobalProviderProps>) => {
	return <GlobalContext.Provider value={{ data, preview }}>{children}</GlobalContext.Provider>;
};

export const useGlobal = () => {
	const ctx = useContext(GlobalContext);

	if (!ctx) {
		throw new Error("useGlobal must be called within a GlobalProvider!");
	}

	return ctx;
};
